import { json } from 'aurelia-fetch-client';
import { Item } from "data/entities/item";
import { TreeViewItem } from "core/tree-view-item";
import { Rest, Config } from 'aurelia-api';
import { autoinject, LogManager } from "aurelia-framework";

@autoinject
export class TreeViewDataService {


	logger = LogManager.getLogger('TreeViewDataService');
    baseUrl: string = 'iteminfo/';

	apiEndpoint: Rest;
	constructor(private apiConfig: Config) {
		this.apiEndpoint = apiConfig.getEndpoint('protected-api');
	}

	async getTopLevelItemAndChildren() {
		try {
			const item = await this.apiEndpoint.find(this.baseUrl + "getTopLevelItemAndChildren");
			this.populateParentProperty(item);
			return item;
		}
		catch (exception) {
			this.logger.error(exception);
		}
		
	}

    populateParentProperty(item) {
        if (!item.children) return;

        item.children.forEach(
            (i) => {
                i.parent = item;
                if (i.children.length > 0) {
                    this.populateParentProperty(i);
                }
            }
        );
    }
	//We need to send only the item, not the entire tree.
    prepItemForSave(item: any): Item {
        let clone = Object.assign({}, item);
        clone.children = null;
        clone.parent = null;
        return clone;
    }

	save(item: Item) {
		var clone = this.prepItemForSave(item);
		return this.apiEndpoint.post(this.baseUrl + item.id, json(clone));
    }
}